import React from 'react';
import { Box, Link as MuiLink, Typography } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import Data from '../data/LabsData';
import Content from './Content';
import TopicNav from './TopicNav';
import PageNotFound from '../pages/PageNotFound';
import { normalizeWorksheetTopics, normalizedHeading, orderedSections } from '../utils/labNavigation';

export default function WorksheetSection({ section }) {
  const { labId } = useParams();
  const data = Data[labId]?.content?.[section];
  if (!data) return <PageNotFound />;

  const topics = normalizeWorksheetTopics(data, section);
  const hasTopicNav = topics.length > 1;
  const sectionName = data.name || section[0].toUpperCase() + section.slice(1);
  const sections = orderedSections(Data[labId].content);
  const currentIndex = sections.findIndex(([key]) => key === section);
  const nextSection = sections[currentIndex + 1];

  return <Box component="form" aria-label={`${sectionName} worksheet`} onSubmit={event => event.preventDefault()}>
    <Typography variant="h2" component="h2" gutterBottom>{sectionName}</Typography>
    <Box sx={{ display: { md: hasTopicNav ? 'grid' : 'block' }, gridTemplateColumns: '12rem minmax(0, 1fr)', gap: 4, alignItems: 'start' }}>
      <TopicNav sectionName={sectionName} topics={topics} />
      <Box sx={{ minWidth: 0, maxWidth: hasTopicNav ? '100%' : '65ch' }}>
        {topics.map(topic => <Box component="section" key={topic.id} id={topic.id} sx={{ mb: 6, scrollMarginTop: '6rem' }}>
          {hasTopicNav && <Typography variant="h3" component="h3" sx={{ mb: 2 }}>{topic.label}</Typography>}
          {topic.steps.map((step, stepIndex) => {
            const stepNamed = step.name && step.name !== 'NOSTEP';
            const showStepHeading = stepNamed && !topic.topicOwnsSteps
              && normalizedHeading(step.name) !== normalizedHeading(topic.label);
            const groupTitle = showStepHeading ? step.name : topic.label;
            const stepHeadingLevel = hasTopicNav ? 'h4' : 'h3';
            const contentHeadingLevel = showStepHeading
              ? hasTopicNav ? 'h5' : 'h4'
              : hasTopicNav ? 'h4' : 'h3';
            return <Box key={`${topic.id}-step-${stepIndex}`} sx={{ mb: 4 }}>
              {showStepHeading && <Typography variant={stepHeadingLevel} component={stepHeadingLevel} sx={{ mb: 2 }}>{step.name}</Typography>}
              <Content contentBlocks={step.contentBlocks} keyPrefix={`${topic.id}-step-${stepIndex}`} section={section}
                groupTitle={groupTitle} headingLevel={contentHeadingLevel} skipHeadingText={groupTitle} />
            </Box>;
          })}
        </Box>)}
      </Box>
    </Box>
    {nextSection && <Box sx={{ mt: 2, pt: 3, borderTop: 1, borderColor: 'divider', maxWidth: '65ch' }}>
      <MuiLink component={Link} to={`/labs/${labId}/${nextSection[1].link || nextSection[0]}`}>
        Continue to {nextSection[1].name}
      </MuiLink>
    </Box>}
  </Box>;
}
